import axios from 'axios'
import { format } from "date-fns";
const store = {
  namespaced: true,
  state: {
    audits: []
  },
  mutations: {
    saveAudits (state, audits) {
      state.audits = audits
    }
  },
  actions: {
    async auditUIEvent(context,auditData){
      try {
          await axios.post('api.public.Public/InsertAudit', {
          action: auditData.action,
          description:auditData.description||"",
          details:auditData.details||""
        })
      }
      catch(e){
        console.log(e)
      }
    },

    async fetchAudits(context,filter){
      try {
          const result = await axios.post('api.public.Public/GetAudits', {
            filter: {...filter, domains: ["*"] } || {}
        })
        let audits = result.data.audits
        audits.forEach(a=>{
            a.created = format(
                new Date(a.created),
                "yyyy-MM-dd HH:mm:ss"
              )
            if(a.details){
                try{
                    a.details = JSON.stringify(JSON.parse(a.details))
                }
                catch(e){
                    return
                }
            }
        })

        context.commit('saveAudits',audits)
      }
      catch(e){
        console.log(e)
      }
    }
  },
  getters: {
    getAudits: (state) => {
        return state.audits
    }
  }
}

export default store
